import { useEffect, useState } from 'react'

const statusMessages = [
  'Authenticating...',
  'Loading your dashboard...',
  'Securing your data...',
  'Initializing application...',
  'Preparing interface...'
]

export function LoadingSpinner() {
  const [statusIndex, setStatusIndex] = useState(0)

  useEffect(() => {
    const statusInterval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statusMessages.length)
    }, 2000)

    return () => clearInterval(statusInterval)
  }, [])

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-sfp-lightgray to-white">
      {/* SVG Animated Circular Progress */}
      <div className="mb-8">
        <svg className="w-32 h-32" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
          {/* Background circle */}
          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke="#E8F0F8"
            strokeWidth="8"
          />

          {/* Animated gradient progress circle */}
          <defs>
            <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#F5A623" />
              <stop offset="100%" stopColor="#E8F0F8" />
            </linearGradient>
          </defs>

          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke="url(#progressGradient)"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="314"
            strokeDashoffset="0"
            style={{
              animation: 'fillCircle 3s cubic-bezier(0.4, 0, 0.2, 1) infinite',
              transformOrigin: '60px 60px',
              transform: 'rotateZ(-90deg)'
            }}
          />

          {/* Center dot accent */}
          <circle
            cx="60"
            cy="60"
            r="6"
            fill="#F5A623"
            style={{
              animation: 'pulse 2s ease-in-out infinite'
            }}
          />
        </svg>
      </div>

      {/* Status Text */}
      <div className="text-center">
        <p className="text-sfp-darkgray text-lg font-semibold tracking-wide min-h-8">
          {statusMessages[statusIndex]}
        </p>
        <p className="text-gray-500 text-sm mt-4">SFP Wealth CRM</p>
      </div>

      <style>{`
        @keyframes fillCircle {
          0% {
            stroke-dashoffset: 314;
            opacity: 0.8;
          }
          50% {
            stroke-dashoffset: 0;
            opacity: 1;
          }
          100% {
            stroke-dashoffset: -314;
            opacity: 0.8;
          }
        }

        @keyframes pulse {
          0%, 100% {
            r: 6;
            opacity: 1;
          }
          50% {
            r: 8;
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  )
}
